// extracted by mini-css-extract-plugin
export default {"root":"styles_root__A8INh","content":"styles_content__kZeci","footText":"styles_footText__pQaDi"};